import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ConsumerApp from './apps/ConsumerApp';
import PartnerApp from './apps/PartnerApp';
import { isPartnerSite } from './utils/siteHost';
import RouteProgress from './components/RouteProgress';
import './index.css';

function App() {
  return (
    <Router>
      {/* EnvBanner is intentionally not mounted: no environment banner is wanted in
          any build. components/EnvBanner.jsx is kept so it can be restored by
          re-adding the import and component here. */}
      <RouteProgress />
      {isPartnerSite() ? <PartnerApp /> : <ConsumerApp />}
    </Router>
  );
}

export default App;
